import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/MyProjects.css';

// Added onProjectClick prop to talk to App.js
const MyProjects = ({ user, onProjectClick }) => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const token = sessionStorage.getItem('token');
                const res = await axios.get('/api/projects/my-projects', {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setProjects(res.data);
                setLoading(false);
            } catch (err) {
                console.error("Error fetching projects:", err);
                setLoading(false);
            }
        };
        fetchProjects();
    }, []);

    if (loading) return <div className="loading-state">Loading your projects...</div>;

    return (
        <div className="my-projects-container">
            <header className="projects-header">
                <h2>My Projects ({projects.length} Active)</h2>
                {/* Note: In your App.js, Create Project is a sidebar button, 
                    but we'll keep this one for convenience */}
            </header>

            <div className="projects-grid">
                {projects.length > 0 ? (
                    projects.map((proj) => (
                        <div key={proj.id} className="project-card">
                            <div className="card-image">
                                {proj.image_url ? (
                                    <img src={`${proj.image_url}`} alt={proj.name} />
                                ) : (
                                    <div className="placeholder-img"></div>
                                )}
                            </div>

                            <div className="card-info">
                                <span className="category-tag">{proj.category || 'General'}</span>
                                <h3>{proj.name}</h3>
                                <p>{proj.description}</p>
                                <div className="card-footer">
                                    <button
                                        className="view-btn"
                                        /* FIXED: Call the parent function instead of local state */
                                        onClick={() => onProjectClick(proj)}
                                    >
                                        View Project
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="empty-state"><p>You haven't created any projects yet.</p></div>
                )}
            </div>
        </div>
    );
};

export default MyProjects;